import { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import { NotFoundError } from "~/src/components/error-pages";
import { Head } from "~/src/components/head";

const i18nNamespaces = ["common"];

const NotFoundPage = () => {
  const { t } = useTranslation(i18nNamespaces);
  return (
    <>
      <Head title={t("common:error.info.default.title")} />
      <NotFoundError />
    </>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, i18nNamespaces)),
    },
  };
};

export default NotFoundPage;
